// components/Footer.jsx
import React from 'react';
import { FaGithub, FaLinkedin, FaEnvelope } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-dark text-white py-8">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h2 className="text-2xl font-bold text-primary mb-2">Dulani Kariyawasam</h2>
            <p className="text-gray-300">Software Engineering Undergraduate</p>
          </div>
          
          <div className="flex space-x-4">
            <a 
              href="https://github.com/dula089" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-primary transition-colors"
            >
              <FaGithub size={24} />
            </a>
            <a 
              href="https://www.linkedin.com/in/dulani-kariyawasam-48a86b294" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-primary transition-colors"
            >
              <FaLinkedin size={24} />
            </a>
            <a 
              href="mailto:hansamalidulani6678@gmail.com" 
              className="text-gray-300 hover:text-primary transition-colors"
            >
              <FaEnvelope size={24} />
            </a>
          </div>
        </div>
        
        <div className="border-t border-gray-700 mt-6 pt-6 text-center">
          <p className="text-gray-400">
            &copy; {currentYear} Dulani Kariyawasam. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;